import React from 'react';
import { bool, string, func } from 'prop-types';
import { Grid, Switch } from '@nextiva/next-ui-components';
import { formatToTestId } from 'utils/validators';

export const ToggleRow = ({ name, value, onToggleRowChange, disabled }) => {
  const handleChange = (event) => {
    onToggleRowChange({ [name]: event.target.checked });
  };

  const formattedName = formatToTestId(name);

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className="m-role-form__role-child"
      data-testid="PlatformAdminUI-RolesAndPermissions-RoleForm-RoleChild"
    >
      <Grid item>{name}</Grid>
      <Grid item>
        <Switch
          checked={value}
          onChange={handleChange}
          disabled={disabled}
          data-testid={`PlatformAdminUI-RolesAndPermissions-RoleForm-${formattedName}-toggle`}
        />
      </Grid>
    </Grid>
  );
};

ToggleRow.propTypes = {
  disabled: bool.isRequired,
  name: string.isRequired,
  value: bool.isRequired,
  onToggleRowChange: func.isRequired,
};

export default ToggleRow;
